import * as React from "react";
import { Text } from "@grandvisionhq/elements";
import { useIntl } from "@grandvisionhq/state";
import { useCheckoutSettings } from "../../../../context/CheckoutSettings/context/CheckoutSettings/context.js";
const ImplicitTermsAndConditionsContainer = () => {
  const { consent } = useCheckoutSettings();
  const { getFormattedLabel, hasLabel } = useIntl();
  const labels = React.useMemo(
    () => ({
      disclaimerCondition: hasLabel("checkout.disclaimer.conditions") ? getFormattedLabel("checkout.disclaimer.conditions", {
        parseLink: true,
        openLinksInNewTab: true
      }) : ""
    }),
    [hasLabel, getFormattedLabel]
  );
  if (!consent?.implicitTermsAndConditions || !labels.disclaimerCondition) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(Text, { className: "checkout-step__terms-and-conditions" }, labels.disclaimerCondition);
};
export {
  ImplicitTermsAndConditionsContainer
};
//# sourceMappingURL=ImplicitTermsAndConditionsContainer.js.map
